// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4e783fc0","498":"a3c9419f","703":"8e86148a"}[chunkId] + ".chunk.js";
};